//
import Model from '@/models/Model'

/**
 * 
 */
export default class extends Model {

    /**
     * 
     */
    resource () {
        return 'confirm'
    }
}